(()=>{
  return
  try {
  window.currencyUpdateLock = false;
  window.dataLayer = window.dataLayer || [];
  window.gtag=window.gtag || function(){dataLayer.push(arguments);}
  const CURRENCY_AB_TEST = {
    url: null,
    id: "412447f7-510d-44e6-838e-104b54a6914c",
    page_type: "all",
    product_handles: [],
    collection_handles: [],
    demographics: {
      bucket: "0-100",
      region: [],
      city_tier: [],
      page_type: "all",
      device_tier: [],
    },
    elements: { items: [] },
    edits: [],
    test_type: "dom",
    redirect_path_template: "",
    redirect_variant_url: "",
    url_query_params: [],
    search_param_name: "",
    search_param_value: "",
    variant_option_name: "",
    variant_option_value: "",
    variant_selection_by_handle: {},
    redirect_urls_by_handle: {
      __default__: "https://akiso-store.myshopify.com/",
    },
    product_excluded_handles: [],
    collection_excluded_handles: [],
    gTag: {
      event: "ab_test_exposure",
      variant_id: "Currency Visibility – Single vs Dual",
      test_id: "412447f7-510d-44e6-838e-104b54a6914c",
    },
  };
function selectFirstIntlVariant() {
  const product = window.current_product;
  
  // Ensure the product JSON exists
  if (!product || !product.variants) {
    console.warn("Product JSON not found. Make sure window.current_product is defined.");
    return;
  }

  // Find the FIRST variant where any of the 3 options equals 'intl'
  // (Shopify allows a max of 3 options per product: option1, option2, option3)
  const targetVariant = product.variants.find(variant => {
    return variant.option1 === 'intl' || 
           variant.option2 === 'intl' || 
           variant.option3 === 'intl';
  });

  if (targetVariant) {
    console.log("Automatically selecting INTL variant ID:", targetVariant.id);
    
    // 1. Update the hidden Variant ID input in the Add to Cart form
    const variantInputs = document.querySelectorAll('form[action*="/cart/add"] [name="id"]');
    variantInputs.forEach(input => {
      input.value = targetVariant.id;
      // Trigger change event so the theme knows the variant was updated
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // 2. Update the URL to reflect the correct variant (so refreshes keep it)
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.set('variant', targetVariant.id);
    window.history.replaceState({}, '', newUrl);

  } else {
    console.log("No 'intl' variant found for this product.");
  }
}
  const BUCKET_MIN = 0;
  const BUCKET_MAX = 100;

  function getBucketNumber() {
    const raw = window.user_bucket;
    if (raw === null || raw === undefined || raw === "") return NaN;
    const n = Number(raw);
    return Number.isFinite(n) ? n : NaN;
  }

  function isUserInTreatmentBucket() {
    const bucket = getBucketNumber();
    if (Number.isNaN(bucket)) return false;
    return bucket >= BUCKET_MIN && bucket <= BUCKET_MAX;
  }

  async function waitForBucketNumber(maxMs) {
    const step = 100;
    const deadline = Date.now() + maxMs;
    while (Date.now() < deadline) {
      if (!Number.isNaN(getBucketNumber())) return true;
      await new Promise((r) => setTimeout(r, step));
    }
    return false;
  }

  function isUserInIndia() {
    const timeOffset = new Date().getTimezoneOffset();
    const testIntl = window.location.search.includes("test_intl");
    if (window.Shopify?.country === "IN" && timeOffset === -330) return true;
    if (testIntl) return false;
    return false;
  }

  function isUserInUS() {
    if (window.location.search.includes("test_us")) return true;
    return String(window.Shopify?.country || "").toUpperCase() === "US";
  }

  function trackEvent(exposed) {
    const test = CURRENCY_AB_TEST;
    const testId = String(test.gTag?.test_id || test.id);
    const eventName = exposed
      ? "ab_test_exposure"
      : "ab_test_not_exposed";
    const variantId = test.gTag?.variant_id || "";
    const send = () => {
        window.gtag("event", eventName, {
          test_id: testId,
          variant_id: variantId,
        });
        return;
    };
    setTimeout(()=>{
     send()
    },2000)
  }

  function injectHiderStyles() {
    const styleId = "currency-style-hider";
    if (document.getElementById(styleId)) return;
    const style = document.createElement("style");
    style.id = styleId;
    style.innerHTML = `
      .money:not(.currency-loaded) {
        opacity: 0 !important;
        visibility: hidden !important;
      }
      .money.currency-loaded {
        opacity: 1;
        visibility: visible;
        transition: opacity 0.2s ease-in;
      }
    `;
    document.head.appendChild(style);
  }

  function runCountrySelectorLogic() {
    const COUNTRY_SELECTOR = 'input[name="mlveda_country"]';
    const firstRadio = document.querySelector(COUNTRY_SELECTOR);
    const fieldset = firstRadio?.closest("fieldset");
    if (!fieldset) return;

    const valueToSelect = isUserInIndia() ? "in" : "intl";
    const radioInput = fieldset.querySelector(`input[value="${valueToSelect}"]`);

    let runCount = 0;
    const interval = setInterval(() => {
      runCount++;
      if (radioInput) {
        if (!radioInput.checked) {
          radioInput.checked = true;
          radioInput.dispatchEvent(new Event("change", { bubbles: true }));
        } else {
          clearInterval(interval);
        }
      }
      if (runCount > 20) clearInterval(interval);
    }, 50);
  }

  function updateCurrencyDisplay(showDualCurrency) {
    if (window.currencyUpdateLock) return;

    const moneySelector = ".money";
    const USD_CONVERSION_RATE = 95;
    injectHiderStyles();

    const usdFormatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    });
    const inrFormatter = new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
    });

    try {
      const userIsIndia = isUserInIndia();
      const userIsUS = isUserInUS();
      const moneyElements = document.querySelectorAll(moneySelector);

      moneyElements.forEach((element) => {
        if (element.classList.contains("currency-loaded")) return;

        if (userIsIndia) {
          const inrValue = element.dataset.currencyInr;
          if (inrValue) element.innerText = inrValue;
          requestAnimationFrame(() => element.classList.add("currency-loaded"));
          return;
        }

        const currentText = element.innerText || element.innerHTML;
        const dual = Boolean(showDualCurrency) && userIsUS;

        if (dual && currentText.includes("$") && /\(₹/.test(currentText)) {
          requestAnimationFrame(() => element.classList.add("currency-loaded"));
          return;
        }

        if (!currentText.includes("$")) {
          const inrNumericValue = parseFloat(currentText.replace(/[^0-9.]/g, ""));
          if (!Number.isNaN(inrNumericValue) && inrNumericValue > 0) {
            const usdValue = inrNumericValue / USD_CONVERSION_RATE;
            const usdStr = usdFormatter.format(usdValue);
            element.innerText = dual
              ? `${usdStr} (${inrFormatter.format(inrNumericValue)})`
              : usdStr;
          }
          requestAnimationFrame(() => element.classList.add("currency-loaded"));
        } else {
          if (dual) {
            const usdNumericValue = parseFloat(currentText.replace(/[^0-9.]/g, ""));
            if (!Number.isNaN(usdNumericValue) && usdNumericValue > 0) {
              const inrFromUsd = usdNumericValue * USD_CONVERSION_RATE;
              element.innerText = `${usdFormatter.format(usdNumericValue)} (${inrFormatter.format(inrFromUsd)})`;
            }
          }
          requestAnimationFrame(() => element.classList.add("currency-loaded"));
        }
      });
    } catch (error) {
      console.warn(error);
      document.querySelectorAll(moneySelector).forEach((el) => {
        el.classList.add("currency-loaded");
      });
    }
  }

  function observerSetup(showDualCurrency) {
    let timeout = null;
    const observer = new MutationObserver(() => {
      clearTimeout(timeout);
      timeout = setTimeout(() => updateCurrencyDisplay(showDualCurrency), 100);
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  async function main() {
    injectHiderStyles();

    let showDualCurrency = false;
    if (isUserInUS()) {
      const exposed = isUserInTreatmentBucket();
      showDualCurrency = exposed;
      trackEvent(exposed);
      selectFirstIntlVariant(); 
    }

    const userIsInIndia = isUserInIndia();
    const countryInput = document.querySelector(
      'input[name="mlveda_country"]:checked'
    );
    const currentSelectedValue = countryInput ? countryInput.value : null;

    if (!userIsInIndia && currentSelectedValue === "in") {
      window.currencyUpdateLock = true;
      runCountrySelectorLogic();
      setTimeout(() => {
        window.currencyUpdateLock = false;
        updateCurrencyDisplay(showDualCurrency);
      }, 1000);
    } else {
      runCountrySelectorLogic();
      updateCurrencyDisplay(showDualCurrency);
    }

    observerSetup(showDualCurrency);

    setTimeout(() => {
      const input = document.querySelector('[name="mlveda_country"]');
      if (input?.parentElement) input.parentElement.style.display = "none";
    }, 200);
  }

  main();
} catch (e) {
  console.warn(e);
  const s = document.createElement("style");
  s.innerHTML =
    ".money { opacity: 1 !important; visibility: visible !important; }";
  document.head.appendChild(s);
}
})()